<script>
    import VueCharts from 'vue-chartjs';
    export default {
        extends: VueCharts.Pie,
        props: ['labels', 'data', 'options'],
        mounted () {
            this.renderChart({
            	labels: this.labels,
            	datasets: this.data
            }, this.options);
        }
    }
</script>